/**
 * Whether the page on screen is the logged-out Companion example (the public showcase). A visitor
 * whose session cookie has expired still carries the auth cookie, so the cookie check alone would
 * hide the site navbar and footer on the public marketing page. The showcase marks itself with
 * `data-companion-showcase` (read from the DOM, so the first client render is already right) and
 * its chrome publisher announces example mode here for later client navigations.
 */
const listeners = new Set<() => void>();
let examplePublishers = 0;

export function subscribeCompanionExampleMode(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Browser only. */
export function companionExampleModeSnapshot(): boolean {
  if (examplePublishers > 0) return true;
  try {
    return document.querySelector("[data-companion-showcase]") !== null;
  } catch {
    return false;
  }
}

/** Called by the chrome publisher while an example-mode page is mounted; returns the release. */
export function holdCompanionExampleMode(): () => void {
  examplePublishers += 1;
  for (const listener of listeners) listener();
  let released = false;
  return () => {
    if (released) return;
    released = true;
    examplePublishers = Math.max(0, examplePublishers - 1);
    for (const listener of listeners) listener();
  };
}
